// extracted by mini-css-extract-plugin
export default {"pdf":"Viewer_pdf__cyBfH","toolbar":"Viewer_toolbar__ULAhy","viewer":"Viewer_viewer__Jy9JL"};